import * as THREE from 'three';
import {
  CARD1Web,
  MouseAction
} from '../../CoordUtils.js';

const DefectType = {
     0: 'junLieL',
     1: 'junLieM',
     2: 'junLieH',
     3: 'blockL',
     4: 'blockH',
     5: 'zongfengL',
     6: 'zongfengH',
     7: 'hengfengL',
     8: 'hengfengH',
     9: 'kengchaoL',
     10: 'kengchaoH',
     11: 'songshanL',
     12: 'songshanH',
     13: 'chengxianL',
     14: 'chengxianH',
     15: 'chezheL',
     16: 'chezheH',
     17: 'bolangL',
     18: 'bolangH',
     19: 'fanyou',
     20: 'blockRepair',
     21: 'hengfengRepair',
     22: 'zongfengRepair',
     23: 'jijiang'
  }


export class GroundDefectLoader {
  constructor(defectModel, sceneManager,info) {
    this.defectModel = defectModel;
    this.sceneManager = sceneManager;
    this.modelMesh = this.draw(defectModel.defectOption,info);

  }

  draw(defectOption,info) {
    this.defectGeom = new THREE.BoxGeometry( defectOption.defectWidth, 0.01, defectOption.defectLength);
    this.defectMaterial = new THREE.MeshPhongMaterial({
      map: new THREE.TextureLoader().load(CARD1Web.Resources.textures[DefectType[defectOption.defecttype]].src)
    });
    var material = new THREE.MeshBasicMaterial( {color: 0x00ff00} );
    this.defectMesh = new THREE.Mesh( this.defectGeom, this.defectMaterial);
    this.defectMesh.oInfo=info;
    this.defectMesh.oSelect=true;
    return this.defectMesh;
  }

  loadModel(){
    return this.defectMesh;
  }
  setStake(startStake, endStake, lookAtPt){
    this.defectMesh.startStake = startStake;
    this.defectMesh.endStake = endStake;
    // TODO:计算旋转的角度
    this.defectMesh.lookAt(lookAtPt);
    // this.defectMesh.rotateX(-Math.PI / 2)
    // this.defectMesh.rotateZ(Math.PI)
  }

}


// WEBPACK FOOTER //
// ./src/plugins/drawings3D/modelDrawing/DirectModel/GroundDefectLoader.js